import { render, staticRenderFns } from "./AdyenBankAccountDetailsForm.vue?vue&type=template&id=f7b20618"
import script from "./AdyenBankAccountDetailsForm.vue?vue&type=script&lang=js"
export * from "./AdyenBankAccountDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports